import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { InteractionSheet } from "../components/InteractionSheet";
import { AppointmentSheet } from "../components/AppointmentSheet";

const ModalsContext = createContext(null);
export const useModals = () => useContext(ModalsContext);

export function ModalsProvider({ children }) {
  const [inter, setInter] = useState({ open: false, initial: null });
  const [appt, setAppt] = useState({ open: false, initial: null });
  const [version, setVersion] = useState(0);

  const openInteraction = useCallback((initial = null) => setInter({ open: true, initial }), []);
  const openAppointment = useCallback((initial = null) => setAppt({ open: true, initial }), []);
  const bump = useCallback(() => setVersion((v) => v + 1), []);

  const value = useMemo(() => ({ openInteraction, openAppointment, version, bump }), [openInteraction, openAppointment, version, bump]);
  return (
    <ModalsContext.Provider value={value}>
      {children}
      <InteractionSheet open={inter.open} initial={inter.initial} onClose={() => setInter({ open: false, initial: null })} onSaved={bump} />
      <AppointmentSheet open={appt.open} initial={appt.initial} onClose={() => setAppt({ open: false, initial: null })} onSaved={bump} />
    </ModalsContext.Provider>
  );
}
